import seedrandom from "seedrandom";
import { buildCrossword, Crossword } from "./crossword";
import { loadLetters, loadWordList, loadWords } from "./loader";
import { shuffleArray } from "./util";
/**
 * Creates a new game.
 * @param mode The game mode
 * @returns The new game
 */
export async function newGame(mode) {
    const rng = mode === "random" ? seedrandom() : seedrandom(new Date().toDateString());
    const words = await loadWordList();
    const randomIndex = Math.floor(rng() * words.length);
    const letterList = await loadLetters(words[randomIndex]);
    shuffleArray(letterList, rng);
    const letterChoices = letterList.map((letter, i) => ({
        letter,
        chosen: false,
    }));
    const wordList = await loadWords(letterList);
    const crossword = buildCrossword(wordList, rng);
    return {
        letterChoices,
        crossword,
        complete: false,
    };
}
